import { render, staticRenderFns } from "./InputMultiSelectUser.vue?vue&type=template&id=32e800a6&"
import script from "./InputMultiSelectUser.vue?vue&type=script&lang=ts&"
export * from "./InputMultiSelectUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports